import { Component, computed, input, output } from '@angular/core';
import { InvestigationStatusResponse } from '@cureskin/api-client/src/server-api/api';

interface NormalizedTest {
  name: string;
  required: boolean;
}

@Component({
  selector: 'investigation-card',
  templateUrl: './investigation-card.component.html',
})
export class InvestigationCardComponent {
  readonly investigationStatus = input<InvestigationStatusResponse>();
  readonly doctorImage = input<string>('');
  readonly uploadClick = output<void>();

  readonly normalizedTests = computed<NormalizedTest[]>(() =>
    (this.investigationStatus()?.investigation?.tests ?? []).map(
      (t) => typeof t === 'string' ? { name: t, required: true } : { name: t.test, required: t.required },
    ),
  );

  onUploadReport(): void {
    this.uploadClick.emit();
  }
}
